import { Observable } from "rxjs";
import { extractEdges } from "./extract-edges";
import { extractNodes } from "./extract-nodes";

export function extractEdgesAndNodes() {
  return function<T>(source: Observable<any>): Observable<any> {
    return source.pipe(
      extractEdges(),
      extractNodes()
    )
  }
}
